import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faAlignLeft,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faBars,
  faBriefcase,
  faBullhorn,
  faCheck,
  faCheckCircle,
  faCircleNotch,
  faChevronLeft,
  faChevronRight,
  faClone,
  faClock,
  faCode,
  faCog,
  faCopy,
  faDesktop,
  faEye,
  faExternalLinkAlt,
  faExclamationTriangle,
  faEyeSlash,
  faFile,
  faGamepad,
  faGlobe,
  faGripVertical,
  faHandPointer,
  faHeading,
  faHome,
  faImage,
  faImages,
  faInfoCircle,
  faLayerGroup,
  faLeaf,
  faLink,
  faLock,
  faMagic,
  faMobileAlt,
  faMousePointer,
  faPen,
  faPenRuler,
  faPlug,
  faPlus,
  faQuestionCircle,
  faQuoteRight,
  faRocket,
  faSave,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faSlidersH,
  faStar,
  faSync,
  faTabletAlt,
  faThLarge,
  faTimes,
  faTrash,
  faTrashAlt,
  faUpload,
  faVideo,
  faWandMagicSparkles,
  faWindowMinimize,
  faArrowsAltV,
  faColumns,
} from "@fortawesome/free-solid-svg-icons";
import { faWpforms } from "@fortawesome/free-brands-svg-icons";

const ICONS: Record<string, IconDefinition> = {
  "align-left": faAlignLeft,
  "arrow-down": faArrowDown,
  "arrow-left": faArrowLeft,
  "arrow-up": faArrowUp,
  "bars": faBars,
  "briefcase": faBriefcase,
  "bullhorn": faBullhorn,
  "check": faCheck,
  "check-circle": faCheckCircle,
  "circle-notch": faCircleNotch,
  "chevron-left": faChevronLeft,
  "chevron-right": faChevronRight,
  "clone": faClone,
  "clock": faClock,
  "code": faCode,
  "cog": faCog,
  "columns": faColumns,
  "copy": faCopy,
  "desktop": faDesktop,
  "eye": faEye,
  "globe": faGlobe,
  "grip-vertical": faGripVertical,
  "hand-pointer": faHandPointer,
  "heading": faHeading,
  "image": faImage,
  "images": faImages,
  "info-circle": faInfoCircle,
  "layer-group": faLayerGroup,
  "link": faLink,
  "lock": faLock,
  "magic": faMagic,
  "mobile-alt": faMobileAlt,
  "mouse-pointer": faMousePointer,
  "pen": faPen,
  "pen-ruler": faPenRuler,
  "plug": faPlug,
  "plus": faPlus,
  "question-circle": faQuestionCircle,
  "quote-right": faQuoteRight,
  "rocket": faRocket,
  "save": faSave,
  "search": faSearch,
  "share-alt": faShareAlt,
  "sliders-h": faSlidersH,
  "star": faStar,
  "sync": faSync,
  "tablet-alt": faTabletAlt,
  "th-large": faThLarge,
  "times": faTimes,
  "trash": faTrash,
  "trash-alt": faTrashAlt,
  "external-link-alt": faExternalLinkAlt,
  "exclamation-triangle": faExclamationTriangle,
  "eye-slash": faEyeSlash,
  "file": faFile,
  "gamepad": faGamepad,
  "home": faHome,
  "leaf": faLeaf,
  "shield-alt": faShieldAlt,
  "upload": faUpload,
  "video": faVideo,
  "wand-magic-sparkles": faWandMagicSparkles,
  "window-minimize": faWindowMinimize,
  "wpforms": faWpforms,
  "arrows-alt-v": faArrowsAltV,
};

interface Props {
  icon: string;
  className?: string;
  spin?: boolean;
}

export function WebsiteIcon({ icon, className, spin }: Props) {
  const definition = ICONS[icon];
  if (!definition) return null;
  return <FontAwesomeIcon icon={definition} className={className} spin={spin} />;
}
